import { darken, getContrastRatio, useTheme } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import { getInterpolatedColor } from "../common/util";

export default function ScoreAvatar(props) {
	const theme = useTheme();

	let { score, size, force } = props;

	let colour = theme.palette.text.primary;
	let bgColour = '#999';

	const sx = {
		border: 1,
		height: size,
		width: size,
		fontSize: size * 0.4,
		color: colour,
		bgColour: bgColour,
		borderColor: darken(bgColour, 0.3),
	};

	if (!score) {
		if( force ){
			return (
				<Avatar variant="rounded" sx={sx}>N/A</Avatar>
			);
		}
		return;
	}

	if (score < 50) {
		bgColour = theme.palette.error.main;
	}
	else {
		bgColour = getInterpolatedColor(score, 50, 100);
	}

	colour = theme.palette.getContrastText(bgColour);

	sx.borderColor = darken(bgColour, 0.3);
	sx.color = colour;
	sx.bgcolor = bgColour;

	score = score.toFixed(0) + '%';

	return (
		<Avatar variant="rounded" sx={sx}>
			{score}
		</Avatar>
	);
}
